module.exports = __webpack_public_path__ + "assets/google-play-it.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/stores/google-play-it.svg
// module id = 438
// module chunks = 19